import { render } from "./SellerMain.vue?vue&type=template&id=3afb1541&scoped=true&ts=true"
import script from "./SellerMain.vue?vue&type=script&lang=ts"
export * from "./SellerMain.vue?vue&type=script&lang=ts"

import "./SellerMain.vue?vue&type=style&index=0&id=3afb1541&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afb1541"]])

export default __exports__